"use client";

const VIRTUAL_TRY_ON_REQUEST_EVENT = "build-a-dress:request-virtual-try-on";

/** Opens the create workspace's shared virtual try-on flow when available. */
export function requestVirtualTryOn(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(VIRTUAL_TRY_ON_REQUEST_EVENT));
}

export function listenForVirtualTryOnRequests(
  listener: () => void
): () => void {
  if (typeof window === "undefined") return () => undefined;

  window.addEventListener(VIRTUAL_TRY_ON_REQUEST_EVENT, listener);
  return () =>
    window.removeEventListener(VIRTUAL_TRY_ON_REQUEST_EVENT, listener);
}
